import gsap from 'gsap';
import { lisa } from '../../sixty/Lisa';

export default {
    delimiters: ['{(', ')}'],
    data() {
        return {
            fpsCap: 30,
        }
    },
    mounted() {
        // AUDIO STUFF
        this.audioCtx = new AudioContext({
            latencyHint: 'interactive',
            sampleRate: 44100
        });
        this.analyser = this.audioCtx.createAnalyser();
        this.analyser.fftSize = 256;
        this.frequencyData = new Uint8Array(this.analyser.frequencyBinCount);
        this.analyser.connect(this.audioCtx.destination);


        // fps management
        this.fpsInterval = 1000 / this.fpsCap;
        this.then = window.performance.now();
        this.startTime = this.then;

        this.isDucking = false;

        // render
        this.render()
    },
    unmounted() {
        cancelAnimationFrame(this.raf)
        this.audioCtx.close()
    },
    methods: {
        duck() {
            this.isDucking = true;
            clearTimeout(this.duckTO)
            gsap.killTweensOf(this.$parent.$refs['audio-ambient'])
            gsap.to(this.$parent.$refs['audio-ambient'], { volume: 0.1, duration: 0.1 });
        },
        unduck() {
            this.isDucking = false;
            clearTimeout(this.duckTO)
            gsap.killTweensOf(this.$parent.$refs['audio-ambient'])
            this.duckTO = setTimeout(() => {
                gsap.to(this.$parent.$refs['audio-ambient'], { volume: 0.5, duration: 2, ease: 'linear' });
            }, 250)
        },
        render(newtime) {
            this.now = newtime;
            this.elapsed = this.now - this.then;

            if (this.elapsed > this.fpsInterval) {
                this.then = this.now - (this.elapsed % this.fpsInterval);

                this.analyser.getByteFrequencyData(this.frequencyData);

                // Calculate the average value of the frequency data
                let sum = 0;
                for (let i = 0; i < this.frequencyData.length; i++) {
                    sum += this.frequencyData[i];
                }
                const average = sum / this.frequencyData.length;
                const speechVolume = average / 64;

                if(lisa.initialized)
                    lisa.speechVolume = speechVolume;

                if(speechVolume > 0.2 && !this.isDucking) {
                    this.duck();
                } else if(speechVolume < 0.2 && this.isDucking) {
                    this.unduck();
                }
            }

            this.raf = requestAnimationFrame(this.render);
        }
    },
    template: `
        <div></div>
    `
}
